import React from 'react';
import { SEO } from 'components/seo';
import { Container, Row, Col } from 'react-bootstrap';
import { NavHeader } from 'components/nav_header';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Footer } from 'components/footer';
import { getEventsImages } from 'components/images/events_images';

const EventsPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const { ladiesSkateHawaii } = getEventsImages();

  return (
    <>
      <SEO pageTitle="Events" />
      <div className="d-flex flex-column h-100">
        <NavHeader />
        <main className="main">
          <div className="wrapper bg-white">
            <div className="content-center">
              <Container style={{ marginTop: 140 }}>
                <Row>
                  <Col className="ms-auto me-auto d-flex justify-content-center">
                    <h1 className="title h2 text-center text-lg-start">
                      Upcoming Events 🗓
                    </h1>
                  </Col>
                </Row>
                <div className="my-5" style={{ maxWidth: 480 }}>
                  <GatsbyImage
                    alt="Multiple Formats"
                    className="img"
                    image={ladiesSkateHawaii}
                    imgStyle={{
                      borderRadius: 12,
                    }}
                    style={{
                      borderRadius: 12,
                    }}
                  />
                </div>
              </Container>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default EventsPage;
